import { render, staticRenderFns } from "./clientesalidas.vue?vue&type=template&id=7496fa06"
import script from "./clientesalidas.vue?vue&type=script&lang=js"
export * from "./clientesalidas.vue?vue&type=script&lang=js"
import style0 from "./clientesalidas.vue?vue&type=style&index=0&id=7496fa06&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports